import React, { FC } from 'react';
import cn from 'classnames';
import Multiclamp from 'react-multi-clamp';
import Check from '@crehana/crehana-icons/lib/CheckNew';
import parseClassnames from '../helpers/parseClassnames';
import transition from '../styles/transition';
import { greenMain } from '../styles/colors';
import Text from '../Text';
import { OPTION, OPTION_DARK } from './classnames';
import { MenuItemProps } from './types';

const MenuItem: FC<MenuItemProps> = ({
  label,
  selected,
  clampText,
  dark,
  className = '',
  datatestid,
  'data-testid': dataTestId,
  ...other
}) => {
  const Tag: keyof JSX.IntrinsicElements = other.href ? 'a' : 'button';

  return (
    <Tag
      className={parseClassnames(className, dark ? OPTION_DARK : OPTION)}
      style={{
        transition: transition(['background-color', 'color']),
      }}
      data-testid={dataTestId || datatestid}
      {...other}
    >
      <Text
        className={cn('overflow-hidden max-h-24', {
          'pr-16': selected,
          'break-all': clampText,
        })}
        color="inherit"
      >
        {clampText && label ? (
          <Multiclamp clamp={1}>{label}</Multiclamp>
        ) : (
          label
        )}
      </Text>
      {selected && <Check size={16} color={greenMain} />}
    </Tag>
  );
};

export default MenuItem;
